<template>
  <div class="tabbaritem" @click="itemClick">
        <div v-if="!isActive"><slot name="item-icon"></slot></div>
        <div v-else><slot name="item-icon-active"></slot></div>
        <div :style="active" class="tabbar-text"><slot name="item-text"></slot></div>
  </div>
</template>

<script>
export default {
  name: "tabbarItem",
  props:{
    link:String,
    activeColor:{
      type:String
    },

  },
  computed:{
    isActive (){
      return this.$route.path.includes(this.link)
    },
    active(){
      return this.isActive ? {color: this.activeColor}:  {}
    }
  },
  methods:{
    itemClick(){
      if(this.$route.path != this.link){
        this.$router.push(this.link)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tabbaritem{
  img {
    margin: 0 auto;
    width: 60px;
    height: 60px;
  }
  .tabbar-text{
    font-family: 'PingFang HK';
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    color: #BDB4BE;
    padding-top:1px;
  }
}
</style>
